
import { WorkflowBadge } from "./WorkflowBadge";

interface WorkflowPricingProps {
  premium: string;
  coverage: string;
  periods: string[];
}

export const WorkflowPricing = ({ premium, coverage, periods }: WorkflowPricingProps) => (
  <div className="mt-4">
    <div className="flex flex-wrap gap-2 mb-4">
      {periods.map((period, i) => (
        <WorkflowBadge key={i} isActive={i === 0}>
          {period}
        </WorkflowBadge>
      ))}
    </div>
    <div className="flex justify-between items-center mb-2">
      <span className="text-neutral text-sm sm:text-base">Premium</span>
      <span className="font-bold text-sm sm:text-base">{premium}</span>
    </div>
    <div className="flex justify-between items-center">
      <span className="text-neutral text-sm sm:text-base">Coverage</span>
      <span className="font-bold text-sm sm:text-base">{coverage}</span>
    </div>
  </div>
);
